import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import * as API from '../api';
import type { ICustomerForEdit, ISelectedCustomerState, TCustomerId } from '../interfaces';
import { toError } from '../errors';

const initialState: ISelectedCustomerState = {
  isFetching: false,
  customer: {},
  error: null,
};

const selectedCustomerSlice = createSlice({
  name: 'selectedCustomerSlice',
  initialState,
  reducers: {
    selectedCustomerRequestFailed: (store, _action: PayloadAction<Error>) => {
      store.isFetching = false;
    },
    selectedCustomerRequestFinished: (store, action: PayloadAction<{ data: ICustomerForEdit }>) => {
      store.customer = action.payload.data.customer;
      store.isFetching = false;
      store.error = null;
    },
    selectedCustomerRequested: (store) => {
      store.isFetching = true;
      store.error = null;
    },
  },
});

export const { selectedCustomerRequestFailed, selectedCustomerRequested, selectedCustomerRequestFinished } = selectedCustomerSlice.actions;
export default selectedCustomerSlice.reducer;

export const fetchCustomer = createAsyncThunk('customer/customerData', async ({ customerId }: { customerId?: TCustomerId }, { dispatch }) => {
  try {
    dispatch(selectedCustomerRequested());
    const data = await API.fetchCustomerForEdit(customerId);
    dispatch(selectedCustomerRequestFinished(data));
  } catch (error) {
    dispatch(selectedCustomerRequestFailed(toError(error)));
  }
});
